export default __webpack_public_path__ + "static/media/159.ef52c1b5.svg";